import cloneDeep from 'lodash/cloneDeep';
import initialState from '../store/initialState';
import {
    UPDATE_CLIENT_INFO_ERROR,
    UPDATE_CLIENT_INFO_STARTING,
    UPDATE_CLIENT_INFO_SUCCESS,
} from '../constants/actionTypes';

export default function updateClientInfoReducer(state = initialState.updateClientInfo, action) {
    switch (action.type) {
        case UPDATE_CLIENT_INFO_STARTING: {
            const newState = cloneDeep(state);
            newState.saving = true;
            newState.saved = false;
            return newState;
        }

        case UPDATE_CLIENT_INFO_SUCCESS: {
            const newState = cloneDeep(state);
            newState.saving = false;
            newState.saved = true;
            newState.data = action.data.clientInfo;

            return newState;
        }

        case UPDATE_CLIENT_INFO_ERROR: {
            const newState = cloneDeep(state);
            newState.saving = false;
            newState.saved = false;
            newState.error = action.err ? action.err : 'Failed to update client info.';
            return newState;
        }

        default: {
            return state;
        }
    }
}
